import {v4 as uuid} from 'uuid';

export function blobToFile(blob: Blob, fileName?: string): File {
  return new File([blob], fileName ?? uuid(), {type: 'text/plain'});
}
